import Header from "./components/Header";
import Hero from "./components/Hero";
import Channels from "./components/Channels";
import Trending from "./components/Trending";
import Headlines from "./components/Headlines";
import Feature from "./components/Feature";
import Plans from "./components/Plans";
import About from "./components/About";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Channels />
        <Trending />
        <Headlines />
        <Feature />
        <Plans />
        <About />
        <Faq />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}